import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';

@Component({
  selector: 'app-candidate-job-match-profile',
  templateUrl: './candidate-job-match-profile.component.html',
  styleUrls: ['./candidate-job-match-profile.component.css']
})
export class CandidateJobMatchProfileComponent implements OnInit {

  @Input() jobMatchId: any;
  @Input() jobId: any;
  @Input() candidateId: any;
  @Input() feedbackUserIdsList: any;
  @Input() context: any;
  @Input() candidateType: any;
  @Input() candidateDetails: any;
  @Input() documentDtoMap: any;
  @Input() sourceScreen: any;
  @Input() formalizeActivityPayload: any;

  tabs: any[];
  validTabs: any[];
  steps: any[];
  companyId: any;
  isCorporateFlag: boolean;
  isCandidateContactDetailsMissing = false;
  jobMatchInfo: any;
  jobLocation: string;
  enabledWorkflowSteps: any;
  isRecruiterScreeningFeedbackAvailable: boolean;
  isPhoneScreenFeedbackAvailable: boolean;
  isInterviewFeedbackAvailable: boolean;
  outreachFeedbackFileName: string;
  generalFileName: string;
  taFileName: string;
  vaFileName: string;
  recruiterScreeningFileName: string;
  phoneScreeningFileName: string;
  interviewFeedbackFileName: string;
  sectionalReport: boolean;
  outreachReportUrl: string;
  taUrl: string;
  vaUrl: string;
  recruiterScreeningFeedbackUrl: string;
  phoneScreenFeedbackUrl: string;
  interviewFeedbackUrl: string;

  constructor(
    private authService: AuthService,
    private jobService: JobService,
    private jobMatchService: JobMatchService,
    private companyService: CompanyService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.tabs = [];
    this.validTabs = [];
    this.steps = [];
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.isCorporateFlag = this.companyService.isCorporateCompany();
    this.isCandidateContactDetailsMissing = false;
    if (this.documentDtoMap) {
      this.candidateDetails = typeof this.documentDtoMap === 'string' ? JSON.parse(this.documentDtoMap) : this.documentDtoMap;
    }
    if (this.context == 'candidateCard') {
      this._loadValidTabs();
      this._ensureActiveTab();
    } else if (this.context !== 'candidateJobComparison') {
      this.getEnabledWorkflowSteps(() => {
        this.getCandidateJobMatchCardInfo(() => {
          this._checkAvailableFeedbackReports(() => {
            this._initFileNames();
            this._loadTabs();
          });
        });
      });
    } else if (this.context === 'candidateJobComparison' && !this.jobMatchId) {
      this._loadTabs();
    } else {
      this.getCandidateJobMatchCardInfo(() => {
        this._initFileNames();
        this._loadTabs();
      });
    }
  }

  getEnabledWorkflowSteps(successCallback) {
    this.jobService.getEnabledWorkflowSteps(this.jobId, (data) => {
      this.enabledWorkflowSteps = data;
      this.steps.push('Outreach');
      angular.forEach(this.enabledWorkflowSteps, (step, key) => {
        this.steps.push(step);
      });
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      if (this.authService.isOnline) {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    });
  }

  getCandidateJobMatchCardInfo(successCallback) {
    this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
      this.jobMatchInfo = data;
      this.jobMatchInfo.name = data.firstName + ' ' + data.lastName;
      this.jobLocation = '';
      if (this.jobMatchInfo.jobLocation !== null) {
        this.jobLocation = this.jobService.getParsedJobLocationText(this.jobMatchInfo.jobLocation, false);
      }

      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    }, undefined);
  }

  _checkAvailableFeedbackReports(successCallback) {
    this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, (data) => {
      let feedbackReports = data.feedbackReportsAvailability;
      this.isRecruiterScreeningFeedbackAvailable = feedbackReports['recruiterScreeningFeedbackReport'];
      this.isPhoneScreenFeedbackAvailable = feedbackReports['phoneScreenFeedbackReport'];
      this.isInterviewFeedbackAvailable = feedbackReports['interviewFeedbackReport'];
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });

  }

  _initFileNames() {
    this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
    this.outreachFeedbackFileName = this.generalFileName + '-outrachFeedback' + '.pdf';
    this.taFileName = this.generalFileName + '-' + this.jobMatchInfo.techAssessmentName + '.pdf';
    this.vaFileName = this.generalFileName + '-' + this.jobMatchInfo.valueAssessmentName + '.pdf';
    this.recruiterScreeningFileName = this.generalFileName + '-RecruiterScreening' + '.pdf';
    this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
    this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
  }

  _loadTabs() {
    if (this.context !== 'candidateJobComparison') {
      this._loadWorkflowSteps();
    }
    this._loadValidTabs();
    this._ensureActiveTab();
  }

  _ensureActiveTab() {
    if (!this.validTabs.some(tab => tab.isActive)) {
      if (this.validTabs.length > 0) {
        this.validTabs[0].isActive = true;
      }
    }
    this.validTabs.forEach(tab => tab.isActive = !!tab.isActive);
  }

  selectTab(tab) {
    this.validTabs.forEach(t => t.isActive = (t === tab));
  }

  getSafeReportUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  _loadWorkflowSteps() {
    this.sectionalReport = false;
    if (this.jobMatchInfo.isSharedRequisition && !this.isCorporateFlag) {
      this.sectionalReport = true;
    }
    if (this.jobMatchInfo && this.jobMatchInfo.outreachReport) {
      this.outreachReportUrl = 'api/jobmatch/outreachFeedbackReport/' + this.jobMatchId + '?companyId=' + this.companyId;
      this.tabs.push({ name: 'Outreach', step: 'Outreach', fileName: this.outreachFeedbackFileName, url: this.outreachReportUrl, safeUrl: this.getSafeReportUrl(this.outreachReportUrl + '#view=fitH'), isLoading: false });
    }
    if (!_.isNull(this.jobMatchInfo.techAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.techAssessmentScore) && this.jobMatchInfo.techAssessmentScore.toString() != '') {
      this.taUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.techAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.techAssessmentInvitationId + '&sectional=' + this.sectionalReport;
      this.tabs.push({ name: 'Tech Assessment', step: 'Tech Assessment', fileName: this.taFileName, url: this.taUrl, safeUrl: this.getSafeReportUrl(this.taUrl + '#view=fitH'), isLoading: false });
    }

    if (!_.isNull(this.jobMatchInfo.valueAssessmentPdfReportURL) && !_.isNull(this.jobMatchInfo.valueAssessmentScore) && this.jobMatchInfo.valueAssessmentScore.toString() != '') {
      this.vaUrl = 'api/candidate/candidatepdfreport?filepath=' + this.jobMatchInfo.valueAssessmentPdfReportURL + '&testinvitationid=' + this.jobMatchInfo.valueAssessmentInvitationId + '&sectional=' + this.sectionalReport;
      this.tabs.push({ name: 'Value Assessment', step: 'Value Assessment', fileName: this.vaFileName, url: this.vaUrl, safeUrl: this.getSafeReportUrl(this.vaUrl + '#view=fitH'), isLoading: false });
    }

    if (this.isRecruiterScreeningFeedbackAvailable) {
      this.recruiterScreeningFeedbackUrl = 'api/jobmatch/getscreeningfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
      this.tabs.push({ name: 'Recruiter Screening', step: 'Recruiter Screening', fileName: this.recruiterScreeningFileName, url: this.recruiterScreeningFeedbackUrl, safeUrl: this.getSafeReportUrl(this.recruiterScreeningFeedbackUrl + '#view=fitH'), isLoading: false });
    }

    if (this.isPhoneScreenFeedbackAvailable) {
      this.phoneScreenFeedbackUrl = 'api/jobmatch/getphonescreenfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
      this.tabs.push({ name: 'Phone Screen(s)', step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, safeUrl: this.getSafeReportUrl(this.phoneScreenFeedbackUrl + '#view=fitH'), isLoading: false });
    }

    if (this.isInterviewFeedbackAvailable) {
      this.interviewFeedbackUrl = 'api/jobmatch/getinterviewfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
      this.tabs.push({ name: 'Interview(s)', step: 'Interview', fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, safeUrl: this.getSafeReportUrl(this.interviewFeedbackUrl + '#view=fitH'), isLoading: false });
    }
  }

  _loadValidTabs() {
    let candidateProfileTab: any = { name: 'Profile', step: 'Profile' };
    if (this.context == 'candidateJobComparison') {
      this.validTabs.push(candidateProfileTab);
      this.validTabs.push({ name: 'Job Profile', step: 'Job Profile' });
      this.validTabs.push({ name: 'Compare', step: 'Compare', isActive: true });
    } else if (this.context == 'candidateJobMatchCard') {
      candidateProfileTab.isActive = true;
      this.validTabs.push(candidateProfileTab);
      this.validTabs.push({ name: 'Job Profile', step: 'Job Profile' });
      this.validTabs.push({ name: 'Compare', step: 'Compare' });
    } else if (this.context == 'candidateCard') {
      candidateProfileTab.isActive = true;
      this.validTabs.push(candidateProfileTab);
    }
    this.validTabs.push({ name: 'Documents', step: 'Documents' });
    if (this.candidateDetails && (this.candidateDetails.isNotification || this.candidateDetails.isLogin)) {
      this.validTabs.map(tab => {
        tab.isActive = tab.name === 'Documents';
      });
    }

    if (this.context != 'candidateCard') {
      angular.forEach(this.steps, (step, index) => {
        angular.forEach(this.tabs, (tab, tabIndex) => {
          if (tab.step == step) {
            this.validTabs.push(tab);
          }
        });
      });

      if (this.steps.length == 0) {
        if (this.jobMatchInfo && this.jobMatchInfo.outreachReport) {
          this.outreachReportUrl = 'api/jobmatch/outreachFeedbackReport/' + this.jobMatchId + '?companyId=' + this.companyId;
          this.validTabs.push({ name: 'Outreach', step: 'Outreach', fileName: this.outreachFeedbackFileName, url: this.outreachReportUrl, safeUrl: this.getSafeReportUrl(this.outreachReportUrl + '#view=fitH'), isLoading: false });
        }
      }
    }
  }
}
